<template>
  <div class="sm-help">
    <div class="sm-help-title">
      {{ title }}
    </div>
    <div class="sm-help-content">
      <template
        v-if="activeCalcType === 'VISUM1' || activeCalcType === 'VISUM'"
      >
        <div class="sm-help-row">
          Расчет процедур статического (на данный момент) пользовательского
          равновесия на базе алгоритмов продукта компании PTV Group.
        </div>
        <div class="sm-help-row">
          Результатом расчета являются значения интенсивности и скорости
          движения на каждом ребере транспортного графа в целом за весь период
          моделирования.
        </div>
      </template>
      <template v-else>
        <div class="sm-help-row">
          Алгоритм расчета динамической модели пользовательского равновесия на
          основе теории кинематических волн. Результатом расчета являются
          значения интенсивности, скорости и плотности потока на каждом ребере
          транспортного графа в каждый момент времени.
        </div>
        <div class="sm-help-row">
          Разработка коллектива Simetra (ООО "А+С Транспроект").
        </div>
      </template>
    </div>
    <template v-if="calcMode === 'one'">
      <div class="sm-help-results" v-if="fieldMax">
        <r-text type="caption" style="margin-right: 8px;">
          0
        </r-text>
        <ul class="sm-help-results-list">
          <li
            class="sm-help-results-item"
            v-for="color in colors"
            :key="color"
            :style="{ backgroundColor: color }"
          />
        </ul>
        <r-text type="caption" style="margin-left: 8px;">
          {{ fieldMax }}
        </r-text>
      </div>
    </template>
    <template v-else>
      <div class="sm-help-results">
        <div class="sm-help-results-block">
          <li
            class="sm-help-results-item"
            :style="{ backgroundColor: 'rgb(85, 183, 126)' }"
          />
          <r-text type="caption" style="margin-left: 8px;">
            больше 0
          </r-text>
        </div>
        <div class="sm-help-results-block">
          <li
            class="sm-help-results-item"
            :style="{ backgroundColor: '#d63838' }"
          />
          <r-text type="caption" style="margin-left: 8px;">
            меньше 0
          </r-text>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import { colors } from "../configs";

export default {
  data() {
    return {
      colors
    };
  },
  computed: {
    calcMode() {
      return this.$store.state.scenarioModelling.calcMode;
    },
    activeCalcType() {
      return this.$store.state.scenarioModelling.activeCalcType;
    },
    title() {
      return this.activeCalcType === "VISUM1" || this.activeCalcType === "VISUM"
        ? "PTV Visum"
        : "RITM DTA";
    },
    fieldMax() {
      return this.$store.state.scenarioModelling.fieldMax;
    }
  }
};
</script>

<style lang="scss">
.sm-help {
  flex-shrink: 0;
  padding-top: 32px;

  &-title {
    color: var(--text_primary) !important;
    font-size: 14px;
  }

  &-row {
    margin-top: 4px;
    color: var(--text_secondary) !important;
    font-size: 12px;
  }

  &-results {
    margin-top: 12px;
    display: flex;
    align-items: center;

    &-list {
      flex: 1;
      display: flex;
      align-items: center;
    }

    &-item {
      height: 12px;
      flex: 1;
      border: 1px solid transparent;
      border-color: var(--dividers_low_contrast) !important;
    }

    &-block {
      display: flex;
      align-items: center;
      width: 50%;

      &:not(:first-child) {
        margin-left: 32px;
      }
    }
  }
}
</style>
